import React, { useEffect, useState } from 'react';
import { useSummaryData } from '../hooks/useSummaryData';
import { ClassName_MONTHLY_ELECTRICITY_USAGE_COSTS, ClassName_MONTHLY_GAS_USAGE_COSTS } from './summaryChartClassnames';
import { UsageAndCostsBaseChart } from '@/components/base-chart/UsageAndCostsBaseChart/UsageAndCostsBaseChart';

export const config = {
  gas: {
    title: 'Monthly Gas Usage and Costs',
    name: 'Gas',
    color: '#c00000',
    unit: 'MMbtu'
  },
  electricity: {
    title: 'Monthly Electricity Usage and Costs',
    name: 'Electricity',
    color: '#4472c4',
    unit: 'kWh'
  }
}

export const ConsumptionAndCostsCharts = ({
  type,
  period,
  endingMonth,
  disableTooltip = false
}) => {

  const { data = {
    [type]: []
  } } = useSummaryData(type, period, endingMonth)
  const chartData = data[type]

  const classname = type === 'gas' ? ClassName_MONTHLY_GAS_USAGE_COSTS : ClassName_MONTHLY_ELECTRICITY_USAGE_COSTS;

  return (
    <UsageAndCostsBaseChart
      data={chartData}
      type={type}
      title={config[type].title}
      className={classname}
      style={{ width: '100%', height: '100%' }}
      customOptions={disableTooltip ? { tooltip: { show: false } } : {}}
    />
  );
}
